export class Structure {
    
    public pathNameProduto(slug: string, thumb: string){
        return require(`@/assets/images/${slug}/produtos/${thumb}`);
    }

    public pathNameAvatar(slug: string, img: string){
        return require(`@/assets/images/${slug}/template/${img}`);
    }

    public bgTemplate(str: any){
        return 'url('+require(`@/assets/app_images/${str}`)+')';
    }

    public countCharacteres(numMax: number, txt: string): number{

        const num = numMax;

        console.log(
            'qtd >>',txt.length,
            'txt campo >>', txt,
            'resultado >>', num - txt.length
        )

        const input: number     = txt.length;
        const output: number    = parseInt((input - numMax).toString().replace(/[^\d]+/g,''));

        return output;
    }
}

export class FormatCurrency {

    public formatMoney(value: string) {
        // value = this.cleanMaskMoney(value);
        value = parseFloat(value).toFixed(2);
        const valorSplit = value.split('.');
        if (valorSplit.length == 1) {
            valorSplit.push('00');
        } else if (valorSplit[1]) {
            valorSplit[1] = Math.round(parseInt(valorSplit[1])).toString();
        }

        let validaDecimal = valorSplit[1];
        if (validaDecimal.length == 1) {
            validaDecimal = '0' + valorSplit[1];
        }
        const casasDecimais = validaDecimal;

        const resto = valorSplit[0];
        let valorFinal = '';

        const qtdCentenas: number[] = [];
        let length = resto.length;

        calcCentenas();
        function calcCentenas() {
            if (length - 3 > 0) {
                qtdCentenas.push(3);
                length = length - 3;
                calcCentenas();
            } else {
                qtdCentenas.push(length);
            }
        }

        let de = 0;
        for (let inde = qtdCentenas.length - 1; inde >= 0; inde--) {
            const dot = inde == 0 ? '' : '.';
            const para = qtdCentenas[inde];
            valorFinal += resto.substring(de, de + para) + dot;
            de += para;
        }

        valorFinal = valorFinal + ',' + casasDecimais;
        return valorFinal;
    }
}

export class ResizeForm {

    public inputResize(classe: string, pad: number){
        const valueCur: string  = (document.querySelector(`.${classe}`) as HTMLInputElement).value ;
        const valueId: any      = valueCur.split(' ').join('_').replace(/[^a-zA-Z 0-9]+/g, '');

        console.log('Helper >>',valueId);
        // $('p').after('<div class="fake_form" id="fake_form_' + valueId + '">' + valueCur + '</div>');
        // var valueInitW = $('#fake_form_' + valueId).width() + 2 + pad;
        // $('#fake_form_' + valueId).remove();
        // $(id).css('width', valueInitW);
    }

}

class calculos {
    public porcentagem(valor: number, total: number): number{
        return (valor/total)*100;
    }
}

export const AutoResizeInput = new ResizeForm();
export const calc            = new calculos();